import React, { useRef, useState, useEffect } from "react";
import { Eraser, Check } from "lucide-react";

export default function SignaturePad({ onSave, width = 500, height = 200 }) {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.strokeStyle = "#003399";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }, []);

  const getPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    return { x: x * (canvasRef.current.width / rect.width), y: y * (canvasRef.current.height / rect.height) };
  };

  const startDraw = (e) => {
    e.preventDefault();
    setDrawing(true);
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const draw = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(x, y);
    ctx.stroke();
    setHasSignature(true);
  };

  const stopDraw = () => setDrawing(false);

  const clear = () => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.strokeStyle = "#003399";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    setHasSignature(false);
  };

  const save = () => {
    if (!hasSignature) return;
    const dataUrl = canvasRef.current.toDataURL("image/png");
    onSave(dataUrl);
  };

  return (
    <div>
      <div style={{
        border: "2px dashed #828790",
        background: "white",
        padding: 4,
        display: "inline-block",
        borderRadius: 4,
      }}>
        <canvas
          ref={canvasRef}
          width={width}
          height={height}
          style={{ display: "block", touchAction: "none", cursor: "crosshair" }}
          onMouseDown={startDraw}
          onMouseMove={draw}
          onMouseUp={stopDraw}
          onMouseLeave={stopDraw}
          onTouchStart={startDraw}
          onTouchMove={draw}
          onTouchEnd={stopDraw}
          data-testid="signature-canvas"
        />
      </div>
      <div style={{ marginTop: 8, display: "flex", gap: 6 }}>
        <button type="button" className="vb-btn" onClick={clear} data-testid="signature-clear">
          <Eraser className="w-3 h-3 inline mr-1" />Hapus
        </button>
        <button type="button" className="vb-btn-primary" onClick={save} disabled={!hasSignature} data-testid="signature-save">
          <Check className="w-3 h-3 inline mr-1" />Konfirmasi Tanda Tangan
        </button>
      </div>
      <div style={{ fontSize: 11, color: "#666", marginTop: 4 }}>
        Tanda tangan menggunakan mouse / sentuhan layar
      </div>
    </div>
  );
}
